/**
 * A colour a chart library can use, from a theme token it cannot read itself: amCharts and
 * Chart.js both parse the string they are given, so `var(--el-color-primary)` means nothing
 * to them and the value has to be taken off the root at render time. Anything that is not
 * a token (`--…`) is passed through, and an unset token falls back to `fallback`.
 */
export function chartColor(color: string, fallback = '#1890ff'): string {
  if (!color.startsWith('--')) return color

  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(color)
    .trim()

  return value || fallback
}
